<script setup>
// Horizontal progress steps (a case moving through review). Steps up to
// and including `current` are shown as done.
defineProps({
  steps: { type: Array, required: true }, // ['Reported', 'Counseled', …]
  current: { type: Number, default: 0 },
});
</script>

<template>
  <ol class="ui-steps">
    <li
      v-for="(step, i) in steps"
      :key="step"
      class="ui-steps__step"
      :class="{ 'ui-steps__step--done': i <= current }"
      :aria-current="i === current ? 'step' : undefined"
    >
      <span class="ui-steps__dot">
        <v-icon v-if="i <= current" size="12">mdi-check</v-icon>
      </span>
      <span class="ui-steps__label">{{ step }}</span>
    </li>
  </ol>
</template>

<style scoped>
.ui-steps {
  display: flex;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.ui-steps__step {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
}
/* Connector to the next step */
.ui-steps__step:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 9px;
  left: calc(50% + 14px);
  right: calc(-50% + 10px);
  height: 2px;
  background-color: var(--border);
}
.ui-steps__step--done:not(:last-child)::after {
  background-color: rgb(var(--v-theme-primary));
}
.ui-steps__dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: 2px solid var(--border-strong);
  border-radius: 9999px;
  background: var(--card);
  color: #fff;
}
.ui-steps__step--done .ui-steps__dot {
  border-color: rgb(var(--v-theme-primary));
  background-color: rgb(var(--v-theme-primary));
}
.ui-steps__label {
  font-size: 12px;
  color: var(--muted-foreground);
}
.ui-steps__step--done .ui-steps__label {
  color: var(--foreground);
}
</style>
